import React from "react";
import './ERSSSubSkillGroupContainer.scss';

export default function ERSSSubSkillGroupContainer({top, bottom}){
  return <div className="erss-sub-skill-group-container">
    <div className="erss-group-top">
      {top}
    </div>
    <div className="erss-group-bottom">
      {bottom}
    </div>
  </div>
}